import { createBlocksForTransactions } from 'helpers/transactionsHelper.js';
import { formatDate } from 'helpers/datesHelper.js';
import _size from 'lodash/size';
export const CHANGE_DATE_BY_TYPE = 'CHANGE_BET_HISTORY_DATE_BY_TYPE';
export const VIRTUAL_TAB_CHANGE_DATE_BY_TYPE = 'VIRTUAL_TAB_CHANGE_BET_HISTORY_DATE_BY_TYPE';
export const CHANGE_ACTIVE_TAB = 'CHANGE_BET_HISTORY_ACTIVE_TAB';
export const VIRTUAL_TAB_CHANGE_ACTIVE_TAB = 'CHANGE_BET_HISTORY_VIRTUAL_ACTIVE_TAB';
export const FETCH_TRANSACTIONS_LIST = 'FETCH_BET_HISTORY_TRANSACTIONS_LIST';
export const FETCH_TRANSACTION_BY_ID = 'FETCH_TRANSACTION_BY_ID';
export const FETCH_EXTERNAL_BET_HISTORY = 'FETCH_EXTERNAL_BET_HISTORY';
export const SET_CURRENT_PAGE = 'SET_BET_HISTORY_CURRENT_PAGE';
export const VIRTUAL_TAB_SET_CURRENT_PAGE = 'VIRTUAL_TAB_SET_BET_HISTORY_CURRENT_PAGE';
export const FETCH_CASHOUTS_LIST = 'FETCH_CASHOUTS_LIST';
export const SET_MAXIMUM_CASHOUT_AMOUNT = 'SET_MAXIMUM_CASHOUT_AMOUNT';
export const RESET_BET_HISTORY_LIST = 'RESET_BET_HISTORY_LIST';
export const CHANGE_ACTIVE_FILTER = 'CHANGE_ACTIVE_FILTER';
export const TOGGLE_LIVE_CURTAIN_FOR_TX_ID = 'TOGGLE_LIVE_CURTAIN_FOR_TX_ID';
export const FILTERED_EXTERNAL_BET_HISTORY = 'FILTERED_EXTERNAL_BET_HISTORY';
export const RESET_CASHOUT_LIST = 'RESET_CASHOUT_LIST';
export const FETCH_MUTLICOUPON_CASHOUTS = "FETCH_MUTLICOUPON_CASHOUTS";
export const DELETE_MUTLICOUPON_CASHOUT_COMBINATION = "DELETE_MUTLICOUPON_CASHOUT_COMBINATION";

const toggleLiveCurtainForTxId = (transactionId, curtainActive) => {
  return {
    type: TOGGLE_LIVE_CURTAIN_FOR_TX_ID,
    payload: { transactionId, curtainActive },
  };
};

const setCurrentPage = (currentPage) => {
  return {
    type: SET_CURRENT_PAGE,
    payload: { currentPage },
  };
};

const setCurrentPageOnVirtualTab = (currentPage) => {
  return {
    type: VIRTUAL_TAB_SET_CURRENT_PAGE,
    payload: { currentPage },
  };
};

const changeDateByType = (dateType, date) => {
  return {
    type: CHANGE_DATE_BY_TYPE,
    payload: {
      dateType,
      date,
    },
  };
};

const changeDateByTypeOnVirtualTab = (dateType, date) => {
  return {
    type: VIRTUAL_TAB_CHANGE_DATE_BY_TYPE,
    payload: {
      dateType,
      date,
    },
  };
};

const changeActiveTab = (activeTab) => {
  return {
    type: CHANGE_ACTIVE_TAB,
    payload: {
      activeTab,
    },
  };
};

const changeActiveTabOnVirtualTab = (virtualActiveTab) => {
  return {
    type: VIRTUAL_TAB_CHANGE_ACTIVE_TAB,
    payload: {
      virtualActiveTab,
    },
  };
};

const changeActiveFilter = (activeFilter) => {
  return {
    type: CHANGE_ACTIVE_FILTER,
    payload: {
      activeFilter,
    },
  };
};

const getTransactionByIdPending = () => {
  return {
    type: `${FETCH_TRANSACTION_BY_ID}_PENDING`,
  };
};

const getTransactionByIdSuccess = (data) => {
  return {
    type: `${FETCH_TRANSACTION_BY_ID}_SUCCESS`,
    payload: {
      data,
    },
  };
};

const fetchExternalBetHistorySuccess = (data) => {
  return {
    type: `${FETCH_EXTERNAL_BET_HISTORY}_SUCCESS`,
    payload: {
      data,
    },
  };
};

const fetchExternalBetHistoryFailure = (error) => {
  return {
    type: `${FETCH_EXTERNAL_BET_HISTORY}_FAILURE`,
    payload: { error },
  };
};

const fetchExternalBetHistoryPending = () => {
  return {
    type: `${FETCH_EXTERNAL_BET_HISTORY}_PENDING`,
  };
};

const filteredExternalBets = (data) => {
  return {
    type: `${FILTERED_EXTERNAL_BET_HISTORY}`,
    payload: {
      data,
    },
  };
};

const fetchTransactionsByFilter = (config = {}) => {
  return async (dispatch, getState, { AccountBetHistoryApi }) => {
    dispatch(fetchTransactionListPending());

    try {
      const {
        AccountBetHistory: { activeTab, currentPage, limit, startDate, endDate },
      } = getState();
      const initialConfig = { activeTab, currentPage, startDate, endDate, limit };

      let { data } = await AccountBetHistoryApi.getTransactionsByFilter({
        ...initialConfig,
        ...config,
      });
      const isNextPageAvailable = data?.length > limit;
      if (isNextPageAvailable) data = data.slice(0, limit);

      data = createBlocksForTransactions(data);

      const multiCashoutAvailable = process.env.MULTI_CASHOUT_AVAILABLE && JSON.parse(process.env.MULTI_CASHOUT_AVAILABLE);
      const cashoutPayload = multiCashoutAvailable 
        // Return only slips which are in 'bet placed' status and aren't MULTI
        ? data.filter(({ statusCode, slipType }) => statusCode === 1 && slipType !== 1000)
          .map(({ transactionId }) => transactionId)
        : false;
      await dispatch(fetchCashouts(config, cashoutPayload));

      const multiCouponCombinationsMap = data.reduce((result, transaction) => {
        // The implementation differs between clients
        switch (CLIENT) {
          case "etoto": {
            const { combinationId, status } = transaction.multiCouponCombinationDetails?.at(0) ?? {}; 
            if (!combinationId || status !== 1) return result;
    
            const combinationIds = result[transaction.transactionId] ?? [];
            combinationIds.push(combinationId);
    
            result[transaction.transactionId] = combinationIds;
            return result;
          }
          case "fuksiarz": // Cashout information pulled in BetHistoryItemDetails->useEffect
          default: {
            return result;
          }
        }
      }, {});
      const multiCouponCombinations = Object.entries(multiCouponCombinationsMap);

      if (multiCouponCombinations.length > 0) {
        await Promise.all(multiCouponCombinations.map(
          ([slipId, combinationIds]) => dispatch(fetchMultiCouponCashouts(slipId, combinationIds))
        ));
      }

      dispatch(fetchTransactionListSuccess({ data, isNextPageAvailable }));
      return data;
    } catch (error) {
      dispatch(fetchTransactionListFailure(error));
      throw error;
    }
  };
};

const processLiveCurtainForTxId = (slipId, curtainData) => {
  return async (dispatch, getState, { AccountBetHistoryApi }) => {
    try {
      const { code, data } = await AccountBetHistoryApi.cashoutPrepareLiveCountDown(
        slipId,
        curtainData
      );

      if (code !== 200) {
        throw { message: 'processLiveCurtainForTxId_error' };
      }
      
      dispatch(toggleLiveCurtainForTxId(slipId, true));
      return data.value;
    } catch (error) {
      throw error;
    }
  };
};

const fetchExternalBetHistory = (config = {}) => {
  return async (dispatch, getState, { AccountVirtualBetHistoryApi }) => {
    dispatch(fetchExternalBetHistoryPending());
    dispatch(changeActiveTabOnVirtualTab('all'));

    try {
      const {
        AccountBetHistory: { virtualStartDate, virtualEndDate, virtualLimit },
      } = getState();
      const initialConfig = {
        date_from: formatDate(virtualStartDate, 'yyyy-MM-dd'),
        date_to: formatDate(virtualEndDate, 'yyyy-MM-dd'),
        limit: virtualLimit,
      };

      const { body } = await AccountVirtualBetHistoryApi.getExternalBetHistory({
        ...initialConfig,
        ...config,
      });

      const data = Object.values(body);
      const result = createBlocksForTransactions(data);

      dispatch(fetchExternalBetHistorySuccess(result));
      dispatch(filteredExternalBets(result));
    } catch (error) {
      dispatch(fetchExternalBetHistoryFailure(error));
      throw error;
    }
  };
};

const filterExternalBetHistory = (data, virtualActiveTab) => {
  return async (dispatch, getState) => {
    let selectedTabCode;
    let result;

    let filteredData = createBlocksForTransactions(data);
    switch (virtualActiveTab) {
      case 'undecided':
        selectedTabCode = 1;
        result = filteredData.filter((item) => item.statusCode == selectedTabCode);
        break;
      case 'lost':
        selectedTabCode = 2;
        result = filteredData.filter((item) => item.statusCode == selectedTabCode);
        break;
      case 'won':
        selectedTabCode = 4; // in RGS status won is translated to cashedout
        result = filteredData.filter((item) => item.statusCode == selectedTabCode);
        break;
      default:
        result = filteredData;
        break;
    }

    dispatch(filteredExternalBets(result));
  };
};

const processRebet = (eventId) => {
  return async (dispatch, getState, { EventsApi }) => {
    try {
      const { code, data } = await EventsApi.getById(eventId);
    } catch (error) {
      throw error;
    }
  };
};

const getTransactionById = (transactionId, combinationId = null) => {
  return async (dispatch, getState, { TransactionApi }) => {
    dispatch(getTransactionByIdPending());
    try {
      const { data: transaction } = await TransactionApi.getBetSlipTransactions(transactionId, combinationId);
      const dataWithBlocks = createBlocksForTransactions([transaction]);
      dispatch(getTransactionByIdSuccess(dataWithBlocks));
    } catch (error) {
      throw error;
    }
  };
};

const processCashoutAmount = (config) => {
  return async (dispatch, getState, { AccountBetHistoryApi }) => {
    const { slipId, type, combinationId, ...model } = config;
    const performCashoutByType = AccountBetHistoryApi[type];

    try {
      const { code, data } = await performCashoutByType(slipId, model, combinationId);

      if (!data?.success) {
        const currentCashoutAmount = data?.currentCashoutAmount;
        if (currentCashoutAmount) {
          dispatch(setMaxCashoutForTxId({ amount: currentCashoutAmount }, slipId));
          throw {
            message: 'cashoutInfo_oddsHasChanged',
            oddsHasChanged: true,
            newCashoutAmount: currentCashoutAmount,
          };
        }

        const messageKey = data?.messageKey;
        if (messageKey) {
          throw { message: messageKey };
        }

        throw { message: `error_${code}` };
      }

      const hasCachoutLiveCurtain = process.env.CASHOUT_LIVE_CURTAIN && JSON.parse(process.env.CASHOUT_LIVE_CURTAIN);
      if (hasCachoutLiveCurtain) {
        dispatch(toggleLiveCurtainForTxId(slipId, false));
      }

      const { AccountBetHistory: { cashoutsMultiCoupon } } = getState();
      if (cashoutsMultiCoupon[slipId]?.combinationIds.has(combinationId)) {
        dispatch(deleteMultiCouponCashoutCombination(slipId, combinationId));
      }
      
      return data;
    } catch (error) {
      throw error;
    }
  };
};

const fetchCashouts = (config, multiCashoutIds = false) => {
  return async (dispatch, getState, { AccountBetHistoryApi }) => {
    try {
      if (multiCashoutIds && Array.isArray(multiCashoutIds) && !_size(multiCashoutIds)) {
        dispatch(resetCashoutList());
        return Promise.resolve();
      }

      let actionType = null;
      if (multiCashoutIds) {
        actionType = AccountBetHistoryApi.getMultiCashouts.bind(null, multiCashoutIds);
      } else {
        actionType = AccountBetHistoryApi.getCashouts.bind(null, config);
      }

      const { code, data } = await actionType();
      dispatch(fetchCashoutsSuccess(data));

      return data;
    } catch (error) {
      throw error;
    }
  };
};

const fetchCashoutsMaximumAmount = (transactionId, combinationId = null) => {
  return async (dispatch, getState, { AccountBetHistoryApi }) => {
    try {
      const { code, data } = await AccountBetHistoryApi.cashoutMaximumAmount(transactionId, combinationId);

      switch (code) {
        case 421: // session is expired
        case 620:
        case 1001: // cashout validation error || cashout not available
        case 1002: // cashout validation error || cashout not available
          throw code;
      }

      dispatch(setMaxCashoutForTxId(data, transactionId, combinationId));
      return data;
    } catch (error) {
      throw error;
    }
  };
};

const refreshBetHistoryList = () => {
  return async (dispatch, getState) => {
    const {
      AccountBetHistory: { startDate, endDate, limit, activeTab, currentPage },
    } = getState();
    const params = {
      endDate,
      startDate,
      limit,
      activeTab,
      currentPage,
    };

    try {
      await dispatch(fetchTransactionsByFilter(params));
    } catch (error) {
      throw error;
    }
  };
};

const resetBetHistoryList = () => {
  return async (dispatch) => {
    dispatch({ type: `${RESET_BET_HISTORY_LIST}` });

    try {
      await dispatch(refreshBetHistoryList());
    } catch (error) {
      throw error;
    }
  };
};

const fetchCashoutsSuccess = (cashouts) => {
  return {
    type: `${FETCH_CASHOUTS_LIST}_SUCCESS`,
    payload: { cashouts },
  };
};
const resetCashoutList = () => {
  return {
    type: `${RESET_CASHOUT_LIST}`,
  };
};
const setMaxCashoutForTxId = (maxAmount, transactionId, combinationId = null) => {
  return {
    type: `${SET_MAXIMUM_CASHOUT_AMOUNT}`,
    payload: { maxAmount, transactionId, combinationId },
  };
};

const fetchTransactionListSuccess = ({ data, isNextPageAvailable }) => {
  return {
    type: `${FETCH_TRANSACTIONS_LIST}_SUCCESS`,
    payload: { data, isNextPageAvailable },
  };
};

const fetchTransactionListPending = () => {
  return {
    type: `${FETCH_TRANSACTIONS_LIST}_PENDING`,
  };
};

const fetchTransactionListFailure = (error) => {
  return {
    type: `${FETCH_TRANSACTIONS_LIST}_FAILURE`,
    payload: { error },
  };
};

const fetchMultiCouponCashouts = (slipId, combinationIds = []) => {
  
  return async (dispatch, getState, { AccountBetHistoryApi }) => {
    try {
      const result = await Promise.all(combinationIds.map(async (combinationId) => {
        const { data } = await AccountBetHistoryApi.cashoutMaximumAmount(slipId, combinationId);
        return { combinationId, amount: data?.amount ?? null };
      }));

      const combinations = result.reduce((result, combination) => {
        if (!combination.amount) return result;
        return result.add(combination.combinationId);
      }, new Set())

      const amount = result.find((item) => item.amount)?.amount ?? null;
      
      dispatch({
        type: FETCH_MUTLICOUPON_CASHOUTS,
        payload: { slipId, amount, combinationIds: combinations }
      });
    } catch {}
  };
}

const deleteMultiCouponCashoutCombination = (transactionId, combinationId) => {
  return { type: DELETE_MUTLICOUPON_CASHOUT_COMBINATION, payload: { transactionId, combinationId } }
}

export {
  changeDateByType,
  changeDateByTypeOnVirtualTab,
  changeActiveTab,
  changeActiveTabOnVirtualTab,
  fetchTransactionsByFilter,
  setCurrentPage,
  setCurrentPageOnVirtualTab,
  fetchCashoutsMaximumAmount,
  resetBetHistoryList,
  refreshBetHistoryList,
  processCashoutAmount,
  processRebet,
  changeActiveFilter,
  processLiveCurtainForTxId,
  toggleLiveCurtainForTxId,
  getTransactionById,
  fetchExternalBetHistory,
  fetchExternalBetHistorySuccess,
  filterExternalBetHistory,
  filteredExternalBets,
  resetCashoutList,
  fetchMultiCouponCashouts
};
